module.exports = __webpack_public_path__ + "img/ic-arrow-up-right.243d0a40.svg";